import { render, staticRenderFns } from "./ChemicalEdit.vue?vue&type=template&id=20fa674a&"
import script from "./ChemicalEdit.vue?vue&type=script&lang=js&"
export * from "./ChemicalEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports